export const COLUMN = "mx-auto w-full max-w-2xl px-4";

export const GRID = "grid w-full grid-cols-2 gap-x-4 gap-y-3";

export const WIDE_VALUE_LENGTH = 28;
